import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useData } from '../contexts/DataContext';
import ProjectGallery from '../components/ProjectGallery';
import Loading from '../components/Loading';
import './ProjectDetail.css';

const ProjectDetail = () => {
  const { slug } = useParams();
  const { getProjectBySlug, loading } = useData();
  const project = getProjectBySlug(slug);

  if (loading) {
    return <Loading />;
  }

  if (!project) {
    return (
      <div className="container" style={{ padding: '100px 20px', textAlign: 'center' }}>
        <h2>Proiectul nu a fost găsit</h2>
        <Link to="/projects" className="btn">Înapoi la Proiecte</Link>
      </div>
    );
  }

  return (
    <div className="project-detail">
      <div className="container">
        {/* Simple Header */}
        <div className="simple-header">
          <Link to="/projects" className="back-link">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
              <path d="M10 18l-8-8 8-8 1.414 1.414L5.828 9H18v2H5.828l5.586 5.586z"/>
            </svg>
            Înapoi la Proiecte
          </Link>
          
          <div className="title-section">
            <div className="title-left">
              <span className="category-tag">
                {project.category?.name || project.category_name || 'Proiect'}
              </span>
              <h1 className="page-title">{project.title}</h1>
              {project.size && <p className="size-info">📐 {project.size}</p>}
            </div>
            
            {project.show_price && project.price && (
              <div className="price-info">
                {project.discount_percentage && (
                  <span className="discount-tag">-{project.discount_percentage}%</span>
                )}
                <div className="price-display">
                  {project.original_price && (
                    <span className="price-old">{project.original_price} lei</span>
                  )}
                  <span className="price-current">{project.price} lei</span>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Main Content */}
        <div className="content-grid">
          {/* Left Column - Gallery + Description */}
          <div className="gallery-column">
            <ProjectGallery
              featuredImage={project.featured_image}
              images={project.images}
              title={project.title}
            />

            {/* Description */}
            <div className="description-section">
              <div className="description-header">
                <h2 className="description-title">Despre Proiect</h2>
                <Link to="/contact" className="header-cta-button">
                  <svg width="18" height="18" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M18 2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h14zm0 2H4v12h14V4zm-2 5l-6 4-6-4V7l6 4 6-4v2z"/>
                  </svg>
                  Contactează-ne
                </Link>
              </div>
              <div className="description-content">
                <p className="description-text">{project.description}</p>
              </div>
            </div>
          </div>

          {/* Right Column - Specifications */}
          <div className="info-column">
            {/* Specifications */}
            {project.specifications && project.specifications.length > 0 && (
              <div className="card specs-card">
                <h3 className="card-title">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <rect x="3" y="3" width="18" height="18" rx="2" strokeWidth="2"/>
                    <line x1="9" y1="3" x2="9" y2="21" strokeWidth="2"/>
                  </svg>
                  Specificații Tehnice
                </h3>
                <div className="specs-list">
                  {project.specifications.map(spec => (
                    <div key={spec.id} className="spec-item">
                      <span className="spec-label">{spec.label}</span>
                      <span className="spec-value">{spec.value}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetail;

